import * as React from 'react';
import './sheetlayout.scss';
import { IconSmile } from '../../basics/icons';
import cn from 'classnames';

interface Props {
  isNavigating?: boolean;
  navForwards?: boolean;
  sheetOpen?: boolean;
  loading?: boolean;
  sidebar: React.ReactNode;
  noSidebar?: boolean;
}

export const SheetLayout: React.FC<React.PropsWithChildren & Props> = ({
  isNavigating = false,
  navForwards = true,
  sheetOpen = false,
  loading = false,
  sidebar,
  children,
  noSidebar = false,
}) => {
  return (
    <section
      className={cn(`sheet-layout sheet-layout--nav-${navForwards ? 'forwards' : 'backwards'}`, {
        'sheet-layout--no-sidebar': noSidebar,
        'sheet-layout--is-navigating': isNavigating,
        'sheet-layout--sheet-open': sheetOpen,
      })}
    >
      <main className={'sheet-layout--main'}>
        <div className={'sheet-layout--main-container'}>
          <div>{!loading ? children : <IconSmile spinning={true} />}</div>
        </div>
      </main>
      <aside className={'sheet-layout--sidebar'}>{sidebar}</aside>
    </section>
  );
};
export default SheetLayout;
